// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SubmissionEvaluationResultFormal } from './submissionEvaluationResultFormal';
import type { SubmissionEvaluationResultDescription } from './submissionEvaluationResultDescription';
import type { SubmissionEvaluationResultAnalysis } from './submissionEvaluationResultAnalysis';
import type { SubmissionEvaluationResultApplication } from './submissionEvaluationResultApplication';
import type { SubmissionEvaluationResultReflection } from './submissionEvaluationResultReflection';

/**
 * Evaluation result of a submission
 */
export interface SubmissionEvaluationResult {
  /** Evaluation of FORMAL dimension */
  formal?: SubmissionEvaluationResultFormal;
  /** Evaluation of DESCRIPTION dimension */
  description?: SubmissionEvaluationResultDescription;
  /** Evaluation of ANALYSIS dimension */
  analysis?: SubmissionEvaluationResultAnalysis;
  /** Evaluation of APPLICATION dimension */
  application?: SubmissionEvaluationResultApplication;
  /** Evaluation of REFLECTION dimension */
  reflection?: SubmissionEvaluationResultReflection;
}
